import styled from '@emotion/styled';

type ChallengeColorBarProps = {
  challengeColor: string | null;
};

// #FFFFFF has been used as a null value for challenge/task colors
export const CHALLENGE_NULL_COLOR = '#FFFFFF';

const ChallengeColorBar = styled('div')<ChallengeColorBarProps>(
  ({ theme }) => ({
    transition: theme.transitions.create('border-top'),
    borderTop: '0 solid transparent',
  }),
  ({ challengeColor }) => {
    const showColorBar =
      challengeColor !== null && challengeColor !== CHALLENGE_NULL_COLOR;

    if (showColorBar) {
      return {
        borderTopColor: challengeColor,
        borderTopWidth: 10,
      };
    }
  },
);

export default ChallengeColorBar;
